/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "toggle_variant_default": "transition-transform group-data-[open]/accordion:[transform:rotateX(180deg)] cursor-pointer",
  "toggle_colors_default": "",
  "toggle_size_default": "",
  "group_colors_default": "",
  "group_size_default": "",
  "group_variant_default": "flex items-center justify-between",
  "content_colors_default": "",
  "content_size_default": "",
  "content_variant_default": "hidden group-data-[open]/accordion:block",
  "colors_default": "",
  "size_default": "",
  "variant_default": "group/accordion"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Accordion");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;